/** Layouts */
import BaseLayout from '@/views/rh/formation/layouts/BaseLayout';
import EditLayout from '@/views/rh/formation/layouts/EditLayout';
import ShowLayout from '@/views/rh/formation/layouts/ShowLayout';

/** Components */
import List from '@/views/rh/formation/components/List';
import Create from '@/views/rh/formation/components/Create';
import Edit from '@/views/rh/formation/components/Edit';
import Show from '@/views/rh/formation/components/Show';

/** Checklist */
import ChecklistList from '@/views/rh/formation_checklist/pages/Checklist';
import ChecklistCreate from '@/views/rh/formation_checklist/pages/ChecklistCreate';
import ChecklistShow from '@/views/rh/formation_checklist/pages/ChecklistShow';
import ChecklistEdit from '@/views/rh/formation_checklist/pages/ChecklistEdit';

import Document from '@/views/fichier/pages/Fichier';

/** Session */
import FormationSessionList from '@/views/rh/formation_session/components/List';

export default [
  {
    path: '/rh/formation',
    component: BaseLayout,
    children: [
      {
        path: '',
        component: List,
        name: 'rh_formation',
        meta: {
          auth: true,
          module: 'rh',
          permission: 'access setting',
        },
      },
      {
        path: 'create/:filter?/:id?',
        component: Create,
        name: 'rh_formation-create',
        meta: {
          auth: true,
          module: 'rh',
          permission: 'access setting',
        },
      },
      {
        path: 'edit/:id',
        component: EditLayout,
        children: [
          {
            path: '',
            component: Edit,
            name: 'rh_formation-edit',
            meta: {
              auth: true,
              module: 'rh',
              permission: 'access setting',
            },
          },
          {
            path: 'checklist',
            component: BaseLayout,
            children: [
              {
                path: '',
                component: ChecklistList,
                name: 'rh_formation_edit_checklist',
                meta: {
                  auth: true,
                  module: 'rh',
                  permission: 'access setting',
                },
              },
              {
                path: 'create',
                component: ChecklistCreate,
                name: 'rh_formation_edit_checklist-create',
                meta: {
                  auth: true,
                  module: 'rh',
                  permission: 'access setting',
                },
              },
              {
                path: 'show/:checklistId',
                component: ChecklistShow,
                name: 'rh_formation_edit_checklist-show',
                meta: {
                  auth: true,
                  module: 'rh',
                  permission: 'access setting',
                },
              },
              {
                path: 'edit/:checklistId',
                component: ChecklistEdit,
                name: 'rh_formation_edit_checklist-edit',
                meta: {
                  auth: true,
                  module: 'rh',
                  permission: 'access setting',
                },
              },
            ],
          },
          {
            path: 'document/:documentUuid',
            component: Document,
            name: 'rh_formation_edit-document',
            meta: {
              auth: true,
              module: 'rh',
              permission: 'access setting',
            },
          },
          {
            path: 'formation-session',
            component: FormationSessionList,
            name: 'rh_formation_edit_session',
            meta: {
              auth: true,
              module: 'rh',
              permission: 'access setting',
            },
          },
        ],
      },
      {
        path: 'show/:id',
        component: ShowLayout,
        children: [
          {
            path: '',
            component: Show,
            name: 'rh_formation-show',
            meta: {
              auth: true,
              module: 'rh',
              permission: 'access setting',
            },
          },
          {
            path: 'checklist',
            component: BaseLayout,
            children: [
              {
                path: '',
                component: ChecklistList,
                name: 'rh_formation_show_checklist',
                meta: {
                  auth: true,
                  module: 'rh',
                  permission: 'access setting',
                },
              },
              {
                path: 'create',
                component: ChecklistCreate,
                name: 'rh_formation_show_checklist-create',
                meta: {
                  auth: true,
                  module: 'rh',
                  permission: 'access setting',
                },
              },
              {
                path: 'show/:checklistId',
                component: ChecklistShow,
                name: 'rh_formation_show_checklist-show',
                meta: {
                  auth: true,
                  module: 'rh',
                  permission: 'access setting',
                },
              },
              {
                path: 'edit/:checklistId',
                component: ChecklistEdit,
                name: 'rh_formation_show_checklist-edit',
                meta: {
                  auth: true,
                  module: 'rh',
                  permission: 'access setting',
                },
              },
            ],
          },
          {
            path: 'document/:documentUuid',
            component: Document,
            name: 'rh_formation_show-document',
            meta: {
              auth: true,
              module: 'rh',
              permission: 'access setting',
            },
          },
          {
            path: 'formation-session',
            component: FormationSessionList,
            name: 'rh_formation_show_session',
            meta: {
              auth: true,
              module: 'rh',
              permission: 'access setting',
            },
          },
        ],
      },
    ],
  },
];
